import { render, staticRenderFns } from "./Fidelizaciones.vue?vue&type=template&id=5d39279e&"
import script from "./Fidelizaciones.vue?vue&type=script&lang=js&"
export * from "./Fidelizaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports